import { DashboardEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const getDashboardOverview = async (): Promise<any> =>
  APIManager.sendGet(DashboardEnds.OVERVIEW, true, {}, {}, axios);

export const DashboardService = {
  getDashboardOverview,
};
